import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Moon } from "lucide-react";
import { V } from "@/lib/vocab";

/* Is it business hours at the community? Asked before a vendor text is sent (iter371). */
export function useSendWindow(tenantId, active = true) {
  const [win, setWin] = useState(null);
  useEffect(() => {
    if (!active || !tenantId) return undefined;
    let alive = true;
    api.get(`/tenants/${tenantId}/field-services/send-window`)
      .then((r) => { if (alive) setWin(r.data); })
      .catch(() => { if (alive) setWin(null); });
    return () => { alive = false; };
  }, [tenantId, active]);
  return win;
}

/* "It's 1:32 AM at the community — the text goes out at 8:00 AM. [ ] Send now anyway" */
export function SendWindowNote({ tenantId, active = true, sendNow, onChange, testid = "send-window" }) {
  const win = useSendWindow(tenantId, active);
  if (!win || !win.after_hours) return null;
  return (
    <div data-testid={`${testid}-note`} className="flex flex-wrap items-start gap-2 rounded-xl border border-indigo-200 bg-indigo-50 px-3.5 py-2.5 text-xs leading-relaxed text-indigo-900">
      <Moon className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <span className="min-w-0 flex-1">
        It's <b>{win.local_time}</b> {win.local_day} at {win.community}. The invite {sendNow ? <>goes out <b>right now</b>.</> : <>waits until <b>{win.send_at_local}</b> so nobody is woken up by a text.</>}
      </span>
      <label className="inline-flex shrink-0 cursor-pointer items-center gap-1.5 font-semibold">
        <input type="checkbox" data-testid={`${testid}-send-now`} checked={!!sendNow} onChange={(e) => onChange(e.target.checked)} />
        Send now anyway
      </label>
    </div>
  );
}

export const heldToast = (held, what = "The invite") =>
  held ? `${what} goes out ${held.send_at_local} (after hours at the ${V.lc("org")})` : null;
